package dev.lingvo.site.components.studio.editor

import dev.lingvo.shared.screenshots.doc.Box
import dev.lingvo.shared.screenshots.doc.FrameKind
import dev.lingvo.shared.screenshots.doc.SceneSpec

/** Panels have one write channel; the stage controls when a new immutable snapshot is published. */
internal interface StudioController {
    val uiState: StudioUiState
    fun dispatch(intent: StudioIntent)
}

/** Intents describe commits or view actions without passing mutable DOM state to the controller. */
internal sealed interface StudioIntent {
    data class Action(val action: StudioAction) : StudioIntent
    data class Select(val id: String, val toggle: Boolean = false, val extend: Boolean = false) : StudioIntent
    data class Property(val ids: Set<String>, val property: LayerProperty) : StudioIntent
    data class SetBox(val id: String, val box: Box) : StudioIntent
    data class Reorder(val id: String, val direction: Int, val extreme: Boolean = false) : StudioIntent
    data class Drop(val id: String, val targetId: String, val inside: Boolean, val after: Boolean) : StudioIntent
    data class Frame(val id: String, val frame: FrameKind) : StudioIntent
    data class Scene(val scene: SceneSpec) : StudioIntent
    data class Localize(val ids: Set<String>, val enabled: Boolean) : StudioIntent
    data class Mirror(val enabled: Boolean?) : StudioIntent
    data class Slot(val id: String) : StudioIntent
    data class Language(val locale: String) : StudioIntent
    data class Device(val device: String) : StudioIntent
    data class Add(val kind: String, val asset: StudioAsset? = null) : StudioIntent
    data class CaptionInput(val value: String) : StudioIntent
    data object CaptionSave : StudioIntent
    data object CaptionCancel : StudioIntent
    data object FocusStage : StudioIntent
    data object UploadCapture : StudioIntent
    data object AskAgent : StudioIntent
    data object Review : StudioIntent
    data object Plan : StudioIntent
    data object RetryFonts : StudioIntent
}

/** A thumbnail service can debounce renderer work without making filmstrip composition do it. */
internal interface StudioThumbnailPort {
    fun committed(state: StudioUiState)
    fun dispose()
}
